import type { ProductSortOption } from '@foodlista/shared/products/sort'
import { useQuery } from '@tanstack/vue-query'

export const PRODUCTS_CACHE_KEYS = {
  byProductId(productId: string) {
    return [`product`, productId]
  },
  bySearch: {
    all(restaurantSlug: string) {
      return ['products/search', restaurantSlug]
    },
    query(restaurantSlug: string, query: MaybeRef<string>, sort: MaybeRef<ProductSortOption>) {
      return [...PRODUCTS_CACHE_KEYS.bySearch.all(restaurantSlug), query, sort]
    },
  },
}

export function useGetRestaurantProductById(productId: string) {
  const { $orpc } = useNuxtApp()

  return useQuery({
    queryKey: [...PRODUCTS_CACHE_KEYS.byProductId(productId), 'all-languages'],
    queryFn: () => {
      return $orpc.restaurants.products.getById({ productId, allLanguages: true })
    },
  })
}

interface UseGetProductsbySearchQueryOptions {
  restaurantSlug: string
  query: MaybeRef<string>
  sort?: MaybeRef<ProductSortOption>
  enabled?: boolean
}

export function useGetProductsbySearchQuery({ restaurantSlug, query, sort = 'newest', enabled = true }: UseGetProductsbySearchQueryOptions) {
  const { $orpc } = useNuxtApp()
  const { locale } = useI18n()

  return useQuery({
    queryKey: computed(() => [...PRODUCTS_CACHE_KEYS.bySearch.query(restaurantSlug, query, sort), locale.value]),
    queryFn: () => {
      return $orpc.restaurants.products.getBySearchQuery({ restaurantSlug, q: unref(query), sort: unref(sort) })
    },
    enabled,
  })
}
